"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Star, Compass, FileText, Map } from "lucide-react";
const resources = [{
  id: 1,
  title: "E-Commerce Revolution for Local Retail",
  description: "A complete digital transformation for a Sumter boutique, increasing online sales by 150% in three months.",
  type: "Web Design",
  date: "Project 2024",
  icon: Star,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_ecommerce_portfolio.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_ecommerce_portfolio.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_ecommerce_portfolio.png-wvc-sizes",
    alt: "E-commerce web design project"
  },
  link: "/PortfolioPage"
}, {
  id: 2,
  title: "Social Growth Strategy for Tech Startups",
  description: "Advanced social media management that scaled a national tech brand's engagement across all major platforms.",
  type: "Social Media",
  date: "Project 2024",
  icon: Compass,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_social_strategy.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_social_strategy.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_social_strategy.png-wvc-sizes",
    alt: "Social media management project"
  },
  link: "/PortfolioPage"
}, {
  id: 3,
  title: "Modern Brand Identity for Real Estate",
  description: "A premium visual identity system including logo design and brand guidelines for a luxury property group.",
  type: "Brand Identity",
  date: "Project 2023",
  icon: FileText,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_branding_identity.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_branding_identity.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_branding_identity.png-wvc-sizes",
    alt: "Brand identity design project"
  },
  link: "/PortfolioPage"
}, {
  id: 4,
  title: "High-Conversion SEO Landing Pages",
  description: "Custom landing page design and SEO strategy that lowered lead acquisition costs by 40% for a service provider.",
  type: "SEO & Design",
  date: "Project 2023",
  icon: Map,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_seo_landing.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_seo_landing.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_seo_landing.png-wvc-sizes",
    alt: "SEO landing page project"
  },
  link: "/PortfolioPage"
}];
export default function Ourworkportfolio() {
  return;
}